import i18next from 'i18next';
import { enUS, pl } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import { SUPPORTED_LANGUAGE } from './supportedLanguages';

export function resolveActiveDateFnsLocale(): Locale {
  if (i18next.language === SUPPORTED_LANGUAGE.polish) {
    return pl;
  }
  return enUS;
}
